import { Menu } from './_models';

export class AppPaths {

  static readonly home_url = '/';

  static readonly signup_path = 'signup';
  static readonly signup_url = '/' + AppPaths.signup_path;

  static readonly signin_path = 'signin';
  static readonly signin_url = '/' + AppPaths.signin_path;

  static readonly security_path = 'profil/logowanie';
  static readonly security_url = '/' + AppPaths.security_path;

  static readonly redirect_path = '';
  static readonly redirect_url = '/' + AppPaths.redirect_path;

  static readonly profile_path = 'profil';
  static readonly profile_url = '/' + AppPaths.profile_path;

  static readonly zgody_path = 'profil/zgody';
  static readonly zgody_url = '/' + AppPaths.zgody_path;

  static readonly notifications_path = 'profil/powiadomienia';
  static readonly notifications_url = '/' + AppPaths.notifications_path;

  static readonly history_path = 'historia';
  static readonly history_url = '/' + AppPaths.history_path;

  static readonly legiony_path = 'aplikacje/legiony';
  static readonly legiony_url = 'https://legionynagrody.legia.pl/legiony.php';

  static readonly store_path = 'aplikacje/fanstore';
  static readonly store_url = 'https://sklep.legia.com';

  static readonly tickets_path = 'aplikacje/bilety';
  static readonly tickets_url = 'https://bilety.legia.com';

  static readonly logout_path = 'signout';
  static readonly logout_url = '/' + AppPaths.logout_path;

  static readonly notfound_path = '404';
  static readonly notfound_url = '/' + AppPaths.notfound_path;

  static readonly main_profile_url = AppPaths.security_url;

  static readonly MainMenu: Menu[] = [
    {
      name: 'main_menu.security',
      url: AppPaths.security_url
    },
    {
      name: 'main_menu.profile',
      url: AppPaths.profile_url,
      active: [AppPaths.zgody_url]
    },
    {
      name: 'main_menu.legiony',
      url: AppPaths.legiony_url,
      app: 'legiony'
    },
    {
      name: 'main_menu.store',
      url: AppPaths.store_url,
      app: 'store'
    },
    {
      name: 'main_menu.tickets',
      url: AppPaths.tickets_url,
      app: 'bilety'
    },
    {
      name: 'Wyloguj',
      url: AppPaths.logout_url,
    }
  ];

  private constructor() {}
}
